import { getRaw, postRaw, postFormRaw } from './methods';

export const ApiService = {
  /**
   * @deprecated Use `import { getRaw } from 'services/api';`
   */
  get: getRaw,
  /**
   * @deprecated Use `import { postRaw } from 'services/api';`
   */
  post: postRaw,
  /**
   * @deprecated Use `import { postFormRaw } from 'services/api';`
   */
  postForm: postFormRaw,
};
